'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CarouselViewport", {
    enumerable: true,
    get: function() {
        return CarouselViewport;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useCarouselViewport = require("./useCarouselViewport");
const _renderCarouselViewport = require("./renderCarouselViewport");
const _useCarouselViewportStylesstyles = require("./useCarouselViewportStyles.styles");
const _CarouselSliderContext = require("../CarouselSlider/CarouselSliderContext");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const CarouselViewport = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useCarouselViewport.useCarouselViewport_unstable)(props, ref);
    (0, _useCarouselViewportStylesstyles.useCarouselViewportStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useCarouselViewportStyles_unstable')(state);
    const context = (0, _CarouselSliderContext.useCarouselSliderContextValues_unstable)(state);
    return (0, _renderCarouselViewport.renderCarouselViewport_unstable)(state, context);
});
CarouselViewport.displayName = 'CarouselViewport';
